// https://cdn-images-1.medium.com/v2/resize:fit:1600/1*vsEM2Vzf5l8dsvY4ApDMEg.jpeg
export const COLOR: Record<string, string> = {
    red: "#ff6663",
    orange: "#feb144",
    yellow: "#fdfd97",
    green: "#77dd77",
    blue: "#9ec1cf",
    purple: "#cc99c9",
    black: "#18191a",

    pink1: "#ffb5e8",
    pink2: "#ff8cee",
    pink3: "#ffccf9",
    pink4: "#fcc2ff",
    pink5: "#f6a6ff",

    purp1: "#b28dff",
    purp2: "#c5a3ff",
    purp3: "#d5aaff",
    purp4: "#ecd4ff",
    purp5: "#fbe4ff",

    blue1: "#dcd3ff",
    blue2: "#a79aff",
    blue3: "#b5b9ff",
    blue4: "#97a2ff",
    blue5: "#afcbff",

    teal1: "#aff8db",
    teal2: "#c4faf8",
    teal3: "#85e3ff",
    teal4: "#ace7ff",
    teal5: "#6eb5ff",

    lime1: "#bffcc6",
    lime2: "#dbffd6",
    lime3: "#f3ffe3",
    lime4: "#e7ffac",
    lime5: "#ffffd1",

    peach1: "#ffc9de",
    peach2: "#ffabab",
    peach3: "#ffbebc",
    peach4: "#ffcbc1",
    peach5: "#fff5ba",

    red1: "#f08080",
    red2: "#ff5349",
    red3: "#dc143c",
    red4: "#df362d",
    red5: "#ff033e",
};

const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return {
        r: result ? parseInt(result[1], 16) : 0,
        g: result ? parseInt(result[2], 16) : 0,
        b: result ? parseInt(result[3], 16) : 0,
    };
};

export const gradient = (
    from: string,
    to: string,
    deg?: number,
): { background: string } => {
    const _from = hexToRgb(from);
    const _to = hexToRgb(to);

    return {
        background: `linear-gradient(${deg ?? 90}deg, rgba(${_from.r}, ${
            _from.g
        }, ${_from.b}, 1) 0%, rgba(${_to.r}, ${_to.g}, ${_to.b}, 1) 100%)`,
    };
};

export const textGradient = (
    from: string,
    to: string,
    deg?: number,
): Record<string, string> => {
    return {
        background: `-webkit-linear-gradient(${deg ?? 225}deg, ${from}, ${to})`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    };
};
